"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var List_1 = __importDefault(require("@mui/material/List"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
/**
 * A wrapper component for grouping the two types of config cards, Question and Product cards
 */
var Component = function (p) {
    var styles = (0, makeStyles_1.default)({
        endPadding: {
            '&:last-child:after': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
            },
        },
    });
    return (Preact.h(List_1.default, { id: "list-container", sx: {
            display: 'flex',
            height: { xs: '100%', md: 'max-content' },
            gap: '16px',
            flexDirection: 'row',
            flexWrap: { xs: 'nowrap', md: 'wrap' },
            boxSizing: 'border-box',
            width: { xs: 'fit-content', md: '100%' },
            justifyContent: 'flex-start',
            alignItems: 'center',
            bgcolor: 'background.paper',
            padding: {
                xs: '0px 0px 0px 16px',
                md: "8px 0px 16px 24px",
            },
        }, className: styles().endPadding }, p.children));
};
exports.Component = Component;
